<template>
  <c-form card-style
    v-model="valid"
    :errors="errors"
    id="CSBPayment"
  >
    <v-card-title>
      クレジットカードを登録
    </v-card-title>

    <v-card-text>
      <c-credit-card-fields
        :form="form"
        :brands="brands"
        :flags="flags"
      />
    </v-card-text>

    <c-card-errors :errors="errors"/>

    <v-card-actions id="step1" style="display: block;width: 100%;text-align: right;">
      <v-spacer/>

      <v-btn
        color="primary" type="submit"
        :disabled="!valid || running"
        v-on:click="clickConfirm"
        id="step1Button"
      >
        次へ
      </v-btn>

    </v-card-actions>

    <v-card-actions id="step2" style="display: none;width: 100%;text-align: right;">
      <v-spacer/>

      <span>確認中...</span>
    </v-card-actions>

    <v-card-actions id="step3" style="display: none;width: 100%;height: 52px;">
      <v-spacer/>

      <v-btn
        color="primary" type="button"
        v-on:click="clickBack"
        style="float: left;"
      >
        戻る
      </v-btn>

      <v-btn
        color="primary" type="submit"
        :loading="running"
        :disabled="!valid || running"
        v-on:click="clickEnter"
        style="float: right;"
      >
        カードを登録する
      </v-btn>

    </v-card-actions>

    <input type="hidden" id="merchant_id" name="merchant_id" :value="paymentApi.connection.merchant_id">
    <input type="hidden" id="service_id" name="service_id" :value="paymentApi.connection.service_id">
    <input type="hidden" id="token" name="token" value="" ref="token">
    <input type="hidden" id="tokenKey" name="tokenKey" value="">

  </c-form>
</template>

<script>
import CForm from '@/components/CForm'
import CCardErrors from '@/components/CCardErrors'
import CCreditCardFields from '@/components/CCreditCardFields'

import store from '@/store'
import * as time from '@/libs/time'
import * as http from '@/libs/http'
import * as api from '@/api'
import { run } from '@/libs/a'

import * as C from '@/consts'
import { createCardData } from './utility'

export default {
  name: 'CSBPayment',
  components: {
    CForm,
    CCardErrors,
    CCreditCardFields
  },
  data: () => ({
    // ユーザID
    userID: 0,

    // フォームデータ
    form: {
      number: '',
      holdername: '',
      expire: {
        year: '',
        month: ''
      },
      cvc: ''
    },

    // フラグ
    flags: {
      disabled: false
    },

    // 決済情報
    paymentApi: store.getters['org/paymentApi'],

    // フォームのバリデーション状態
    valid: true,

    // フォームのエラーメッセージ
    errors: [],

    // 処理中
    running: false
  }),

  computed: {
    brands () {
      return this.getters['org/paymentApi'].supportBrands
    }
  },

  created () {
    run(() => {
      // ログイン中のユーザID を取得する
      const userID = store.getters['user/id']
      if (!userID) {
        throw new Error('The user is not logged in.')
      }

      this.userID = userID

      // expire の初期値を設定する
      const now = new Date()
      this.form.expire.year = time.format('Y', now)
      this.form.expire.month = time.format('m', now)
    })
  },

  methods: {
    /**
     * 戻るボタンクリック
     */
    clickBack () {
      // プログレス表示
      this.flags.disabled = false
      document.getElementById('step1').style.display = 'block'
      document.getElementById('step2').style.display = 'none'
      document.getElementById('step3').style.display = 'none'
    },

    /**
     * 次へボタンクリック
     */
    clickConfirm () {
      run(async () => {
        // エラー表示を消す
        this.errors = []

        // プログレス表示
        this.flags.disabled = true
        document.getElementById('step1').style.display = 'none'
        document.getElementById('step2').style.display = 'block'
        document.getElementById('step3').style.display = 'none'

        // トークンを取得
        this.getToken(this.form)
      })
    },

    /**
     * 登録ボタンクリック
     */
    clickEnter () {
      run(async () => {
        // エラー表示を消す
        this.errors = []

        // プログレス表示
        this.running = true

        // カードを登録する
        this.newCard(this.form)
      })
    },

    /**
     * トークン取得
     *
     * @param {Object} from フォームデータ
     */
    async getToken (form) {
      // パラメータ
      const ccNumber = parseInt(form.number)
      const ccExpiration = parseInt(this.getExpireYM(form.expire))
      const securityCode = parseInt(form.cvc)

      // トークン初期化
      document.getElementById('token').value = ''
      document.getElementById('tokenKey').value = ''

      // トークン取得
      window.com_sbps_system.generateToken(
        {
          merchantId: document.getElementById('merchant_id').value,
          serviceId: document.getElementById('service_id').value,
          ccNumber: ccNumber,
          ccExpiration: ccExpiration,
          securityCode: securityCode
        },
        function (response) {
          // トークン取得結果
          if (response.result === 'OK') {
            document.getElementById('step1').style.display = 'none'
            document.getElementById('step2').style.display = 'none'
            document.getElementById('step3').style.display = 'block'
            document.getElementById('token').value = response.tokenResponse.token
            document.getElementById('tokenKey').value = response.tokenResponse.tokenKey
          } else {
            alert('クレジットカードが確認できませんでした\n入力情報に誤りがないか再度ご確認ください')
          }
        }
      )

      if (document.getElementById('token').value === '') {
        this.clickBack()
      }
    },

    /**
     * カード登録API
     *
     */
    async newCard (form) {
      // パラメータ取得
      const params = {
        token: document.getElementById('token').value,
        tokenKey: document.getElementById('tokenKey').value
      }

      // 送信するデータを作成する
      const data = createCardData(this.form, params)

      // API でカードを登録する
      const resp = await api.newUserPayment(this.userID, {
        type: C.PAYTYPE_CARD,
        data
      })

      // エラーチェック
      let errFlg = false
      let errMessage = ''
      if (resp.status === http.Conflict) {
        // 既に同じ内容が登録されている
        errMessage = REASON_ALREADY_REGISTERED
        errFlg = true
      } else if (resp.status !== http.Created) {
        // Payment Provider からエラーが返送された
        errMessage = REASON_CERTIFY_ERROR
        errFlg = true
      }

      if (errFlg === true) {
        alert(errMessage)
        this.running = false
        document.getElementById('token').value = ''
        document.getElementById('tokenKey').value = ''
        this.clickBack()
        return
      }

      // 前のページに戻る
      // this.back()
      this.goTo(this.getters['org/topRoute'])
    },

    /**
     * 有効期限を返す
     *
     * @param {Object} expire 有効期限
     * @returns {String} 有効期限の末日を返す
     */
    getExpireYM (expire) {
      // 1日を示す Date オブジェクトを作成する
      const tm = time.create({ y: expire.year, m: expire.month, d: 1 })

      // 末日にする
      tm.setMonth(tm.getMonth() + 1, 0)

      // 文字列にして返す
      return time.format('Ym', tm)
    }
  }
}

const REASON_ALREADY_REGISTERED = [
  'このカード情報は既に登録されています。'
]

const REASON_CERTIFY_ERROR = [
  'カードが認証できませんでした。\n入力情報に誤りがないか再度ご確認ください'
]

</script>
